import { useMutation } from "@tanstack/react-query";

import { startMfaSetupRequest } from "../requests/start-mfa-setup-request";

export const useStartMfaSetupMutation = () => {
  return useMutation({
    mutationFn: startMfaSetupRequest,
  });
};
